import React from 'react';
import {Accordion} from 'react-bootstrap';


const App1 = () => (
    <div className="DocumentLinksPage__content-container">
        <h2>Сведения о ходе приема:</h2>
        <ul>
            <li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/prisvoenie_UIK.PDF" rel="noopener noreferrer">Порядок
                присвоения идентификационного
                кода</a></li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=ENTRANCESTATFORALL&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Информация о количестве поданных заявлений</a>
            </li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=ENTRANTLIST&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Списки лиц, подавших документы, необходимые для поступления</a>
            </li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=RECOMMENDEDLIST&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Ранжированные списки</a>
            </li>
        </ul>

        <h5>Сведения о зачислении:</h5>
        <ul>
            <li><a href="/pdf/orders_of_enrollment/master/sveden_priem_968.pdf" target="_blank"
                   rel="noopener noreferrer">Сведения о зачислении от 01.08.2025 № 968-ЛСО (очно, установленная квота)</a>
            </li>
        </ul>
    </div>
);

export default App1;
